module.exports = __webpack_public_path__ + "img/head.2a1576d.png";